// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer.css — common copyright ribbon (Footer.jsx) */

.common-footer-ribbon {
  flex-shrink: 0;
  margin-top: auto;            /* sits at the bottom when the page is short */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 46px;
  box-sizing: border-box;
  padding: 14px 0;
  background: #00C2A8;
  color: #ffffff;
  font-size: 0.83rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,cAAc;EACd,gBAAgB,aAAa,8CAA8C;EAC3E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["/* Footer.css — common copyright ribbon (Footer.jsx) */\n\n.common-footer-ribbon {\n  flex-shrink: 0;\n  margin-top: auto;            /* sits at the bottom when the page is short */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 46px;\n  box-sizing: border-box;\n  padding: 14px 0;\n  background: #00C2A8;\n  color: #ffffff;\n  font-size: 0.83rem;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
